/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_back = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Back to Toolverse`)
};

const es_privacy_back = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Volver a Toolverse`)
};

const de_privacy_back = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Zurück zu Toolverse`)
};

const nl_privacy_back = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Terug naar Toolverse`)
};

const fr_privacy_back = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Retour à Toolverse`)
};

const it_privacy_back = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Torna a Toolverse`)
};

const pt_br2_privacy_back = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Voltar para Toolverse`)
};

const pt_privacy_back = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Voltar para Toolverse`)
};

const ja_privacy_back = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Toolverseに戻る`)
};

const zh_privacy_back = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← 返回Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_back = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_back(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_back", locale)
	if (locale === "en") return en_privacy_back(inputs)
	if (locale === "es") return es_privacy_back(inputs)
	if (locale === "de") return de_privacy_back(inputs)
	if (locale === "nl") return nl_privacy_back(inputs)
	if (locale === "fr") return fr_privacy_back(inputs)
	if (locale === "it") return it_privacy_back(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_back(inputs)
	if (locale === "pt") return pt_privacy_back(inputs)
	if (locale === "ja") return ja_privacy_back(inputs)
	return zh_privacy_back(inputs)
};